// Central UI data (poles definition, disciplines, tariffs, association info)

export const PORTES_OUVERTES_URL = "https://www.helloasso.com/associations/heel-events/adhesions/portes-ouvertes-afrolat-studio-saison-2026-2027-2";
export const PORTES_OUVERTES_WIDGET_URL = PORTES_OUVERTES_URL + "/widget";

export const QUEENS_SHOW = {
  name: "Queens",
  tagline: "Les grandes voix féminines américaines — Revue cabaret",
  description: "Queens célèbre les grandes figures et voix féminines américaines, des années 1940 à aujourd’hui. Chant, danse et pole se rencontrent dans une revue où les artistes font vivre toute l’énergie du cabaret. L’expérience se prolonge dans la salle : ouvreuses, mise en scène de l’espace, échanges avec le public et pole au cœur du spectacle.",
  collab: "En collaboration avec Perra Queen et ses deux danseurs.",
  points: ["Chant, danse & pole dance", "Immersion en salle avec le public", "Adaptable : CE, théâtres, casinos, cabarets, événements privés"],
  price: "Tarif sur devis",
  contact: "heeleventscie@gmail.com",
  phone: "07 83 77 45 15",
  instagram: "heelevents_compagnie",
  plaquette: "/docs/plaquette-hecie-2026.pdf",
  photos: ["/images/queens-1.webp", "/images/queens-2.webp", "/images/queens-3.webp", "/images/queens-4.webp", "/images/queens-5.jpg", "/images/queens-6.jpg", "/images/queens-7.jpg", "/images/queens-8.jpg", "/images/queens-9.jpg"],
};

export const COMPAGNIE_UNIVERS = [
  { name: "J’ai Deux Amours", format: "Revue spectacle", duration: "1 h 15", desc: "Un tour du monde comme des inséparables, au gré des aventures de Joséphine et Joe — danse, chant et arts circassiens." },
  { name: "French Bisou", format: "Show", duration: "50 min", desc: "De la France d’antan à celle d’aujourd’hui : nos artistes vous font réviser vos grands classiques, en danse et en musique." },
  { name: "Karaïbet", format: "Show tropical", duration: "50 min", desc: "Magique tour de la Caraïbe aux rythmes de la biguine, du zouk, du mérengue, de la salsa et de la soca." },
  { name: "Sweet Africa", format: "Show", duration: "50 min", desc: "L’Afrique dans toute sa splendeur : danse orientale, kizomba, afro heels, sabar, afro tribal, semba…" },
  { name: "American Dreams", format: "Show", duration: "50 min", desc: "Broadway, Las Vegas, la Route 66 et la Motown : l’entertainment à l’américaine sous toutes ses formes." },
  { name: "Voyage", format: "Show participatif", duration: "50 min", desc: "Le tour du monde en musique live : Antilles, Afrique, Océanie, Brésil, Inde, Espagne — pour petits et grands." },
];

export const PRESTATION_PHOTOS = ["/images/prestations-1.webp", "/images/prestations-2.webp", "/images/prestations-3.webp", "/images/prestations-4.webp", "/images/prestations-5.webp", "/images/prestations-6.jpg", "/images/prestations-7.jpg", "/images/prestations-8.jpg", "/images/prestations-9.webp", "/images/prestations-10.jpg", "/images/prestations-11.jpg", "/images/prestations-12.jpg", "/images/prestations-13.jpg", "/images/prestations-14.jpg", "/images/prestations-15.webp", "/images/prestations-16.webp"];
export const PRESTATION_VIDEO = "/videos/prestations-carnaval.mp4";

export const JDA_SHOW = {
  name: "J’ai Deux Amours",
  tagline: "Revue spectacle — le voyage est plus beau à deux",
  description: "Cette revue vous fera faire un tour du monde comme des inséparables, au gré des aventures de Joséphine et Joe. Le duo est au centre de ce spectacle, en danse, en chant ou en art circassien. Ce voyage vous semblera plus beau à deux.",
  points: ["Le duo au cœur du spectacle", "Danse, chant & arts circassiens", "Adaptable : CE, théâtres, casinos, cabarets, événements privés"],
  duration: "1 h 15",
  price: "Tarif sur devis",
  contact: "heeleventscie@gmail.com",
  phone: "07 83 77 45 15",
  instagram: "heelevents_compagnie",
  plaquette: "/docs/plaquette-hecie-2026.pdf",
  photos: ["/images/jda-1.webp", "/images/jda-2.jpg", "/images/jda-3.jpg", "/images/jda-4.jpg", "/images/jda-5.jpg", "/images/jda-6.jpg", "/images/jda-7.jpg", "/images/jda-8.jpg", "/images/jda-9.jpg", "/images/jda-11.jpg", "/images/jda-12.jpg", "/images/jda-13.jpg", "/images/jda-14.jpg", "/images/jda-15.jpg"],
};
export const INSCRIPTIONS_URL = "https://www.helloasso.com/associations/heel-events/adhesions/inscriptions-afrolat-studio-saison-2026-2027";

export const ASSOC = {
  name: "Heel'Events",
  slogan: "De l'école à la scène, une même passion : danser ensemble.",
  since: 2012,
  president: "Aurélie",
  address: "8 allée de la Favorite, 94260 Fresnes",
  phone: "07 83 77 45 15",
  emails: ["heelevents@gmail.com", "afrolatstudio@gmail.com"],
  instagram: "@heelevents_afrolatstudio",
  instagramUrl: "https://instagram.com/heelevents_afrolatstudio",
  cities: ["Fresnes", "L'Haÿ-les-Roses", "Chevilly-Larue"],
};

export const POLES = [
  {
    slug: "afrolat-studio",
    name: "Afrolat'Studio",
    tagline: "Un studio, une famille, une passion.",
    short: "L'école de danse de Heel'Events. Cours, stages et ateliers pour enfants, ados et adultes.",
    image: "/images/afrolat-studio-cover.webp",
    logo: "/logos/afrolat-studio.webp",
    span: "featured",
    long: [
      "Afrolat'Studio est le principal pôle d'enseignement de Heel'Events.",
      "Cours collectifs, stages et ateliers autour des danses afro, latino, caribéennes, urbaines, danses de couple et solo, ainsi que des activités chorégraphiques et dansées fitness.",
      "Enfants, ados et adultes — plusieurs niveaux selon les disciplines : débutant, intermédiaire, avancé et tous niveaux.",
      "L'école accueille également des pratiquants en situation de handicap lorsque les conditions du cours le permettent.",
    ],
  },
  {
    slug: "heels-compagnie",
    name: "Heel's la Compagnie",
    tagline: "La scène, en mouvement.",
    short: "La dimension scène et spectacle de Heel'Events : créations, performances et prestations artistiques.",
    image: "/images/compagnie-cover-troupe.jpg",
    logo: "/logos/heels-compagnie.png",
    long: [
      "Heel's la Compagnie rassemble des danseurs autour de projets chorégraphiques, spectacles et performances.",
      "Cette page présente la compagnie, ses créations, ses castings éventuels et permet de nous contacter pour toute demande de prestation artistique.",
    ],
  },
  {
    slug: "solidarite",
    name: "Heel'Events Solidarité",
    tagline: "Danser, transmettre, rassembler.",
    short: "Les actions solidaires, sociales et inclusives portées par l'association.",
    image: "https://images.unsplash.com/photo-1787647562452-334f8e9f7c1c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxkaXZlcnNlJTIwZ3JvdXAlMjBkYW5jZSUyMGNsYXNzJTIwY29tbXVuaXR5fGVufDB8fHx8MTc4ODA0NzkzM3ww&ixlib=rb-4.1.0&q=85",
    logo: "/logos/solidarite.png",
    long: [
      "Heel'Events est également une association engagée.",
      "Ce pôle rassemble les projets solidaires, actions locales, partenariats et démarches d'inclusion.",
      "Les contenus détaillés seront ajoutés au fil des projets.",
    ],
  },
  {
    slug: "entree-des-artistes",
    name: "L'Entrée des Artistes",
    tagline: "L'espace des créations et des rencontres.",
    short: "Un espace lié à la création artistique, aux artistes et aux projets scéniques de l'association.",
    image: "https://images.unsplash.com/photo-1635164416977-192869952a6f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwyfHxraXpvbWJhJTIwc2Fsc2ElMjBjb3VwbGUlMjBkYW5jaW5nJTIwYmxhY2t8ZW58MHx8fHwxNzg4MDQ3OTM0fDA&ixlib=rb-4.1.0&q=85",
    logo: "/logos/entree-des-artistes.png",
    long: [
      "L'Entrée des Artistes est l'espace des artistes, des rencontres et des projets scéniques ou événementiels de Heel'Events.",
      "Les contenus de cette page évolueront au fil des collaborations.",
    ],
  },
];

export const DISCIPLINES = [
  { slug: "afrolat-fusion", name: "Afrolat'Fusion", tag: "afro", desc: "Fusion afro-latino, énergique et sensuelle." },
  { slug: "afrolatin-kids", name: "Afrolatin Kids", tag: "kids", desc: "Danse afro-latino pour les enfants — plaisir, rythme, expression." },
  { slug: "salsa-porto", name: "Salsa Porto", tag: "couple", desc: "Danse de couple, sociale et joyeuse." },
  { slug: "kizomba", name: "Kizomba", tag: "couple", desc: "Douceur, connexion et musicalité." },
  { slug: "urban-kiz", name: "Urban Kiz", tag: "couple", desc: "Variante moderne et urbaine de la kizomba." },
  { slug: "k-pop", name: "K-Pop", tag: "urban", desc: "Chorégraphies rythmées et actuelles." },
  { slug: "dancehall", name: "Dancehall", tag: "urban", desc: "Univers urbain, puissance et attitude." },
  { slug: "danse-orientale", name: "Danse orientale", tag: "oriental", desc: "Élégance, isolations et raffinement." },
  { slug: "heels", name: "Heels", tag: "heels", desc: "Talons hauts, street-jazz contemporain, attitude." },
  { slug: "latin-training", name: "Latin'Training", tag: "fitness", desc: "Fitness sur rythmes latinos — cardio et tonicité." },
];

export const CATEGORIES = [
  { value: "all", label: "Toutes" },
  { value: "afro", label: "Afro / Latino" },
  { value: "couple", label: "Danses de couple" },
  { value: "urban", label: "Urbain" },
  { value: "oriental", label: "Orientale" },
  { value: "heels", label: "Heels" },
  { value: "fitness", label: "Fitness / Training" },
  { value: "kids", label: "Enfants" },
];

export const DAYS = ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"];

export const TARIFS = {
  title: "Choisissez votre formule",
  subtitle: "Une formule adaptée à votre rythme, avec la possibilité de protéger votre abonnement annuel grâce à l’option Assurtacotiz.",
  membershipNote: "Adhésion annuelle Heel'Events obligatoire : 20 € adulte / 15 € enfant ou tarif réduit.",
  formulas: [
    {
      slug: "decouverte",
      name: "Découverte",
      price: "30 €",
      priceNum: 30,
      period: "3 cours",
      annual: false,
      insurance: null,
      total: null,
      cta: "Choisir Découverte",
      highlight: false,
      features: ["3 cours pour découvrir", "Idéal pour commencer", "Assurance non applicable"],
    },
    {
      slug: "essentiel",
      name: "Essentiel",
      price: "270 €",
      priceNum: 270,
      period: "par an",
      annual: true,
      insurance: { price: "20 €", priceNum: 20 },
      total: { price: "290 €", priceNum: 290 },
      cta: "Choisir Essentiel",
      highlight: false,
      features: ["Un cours hebdomadaire", "Progression accompagnée toute la saison"],
    },
    {
      slug: "passion",
      name: "Passion",
      price: "400 €",
      priceNum: 400,
      period: "par an",
      annual: true,
      insurance: { price: "20 €", priceNum: 20 },
      total: { price: "420 €", priceNum: 420 },
      cta: "Choisir Passion",
      highlight: false,
      features: ["Accès élargi aux cours", "Pour les pratiquants réguliers"],
    },
    {
      slug: "unlimited",
      name: "Unlimited",
      price: "550 €",
      priceNum: 550,
      period: "par an",
      annual: true,
      insurance: { price: "27,50 €", priceNum: 27.5 },
      total: { price: "577,50 €", priceNum: 577.5 },
      cta: "Choisir Unlimited",
      highlight: true,
      features: ["Accès illimité aux cours", "La liberté totale de danser"],
    },
  ],
  insurance: {
    name: "Assurtacotiz",
    intro: "Afrolat’Studio vous propose, en option, l’assurance Assurtacotiz pour protéger financièrement votre abonnement annuel en cas de certains imprévus couverts par le contrat.",
    rule: "5 % du montant de l’abonnement annuel, avec un minimum de 20 € par an.",
    age: "L’option Assurtacotiz peut être souscrite quel que soit l’âge de l’adhérent. Elle concerne uniquement les abonnements et cours souscrits pour l’année.",
    covers: [
      "Blessure ou maladie (sport, loisirs ou travail)",
      "Prise en charge possible à partir de 4 semaines d’arrêt consécutives",
      "Franchise de 15 jours par arrêt",
      "Déménagement de plus de 30 km (divorce ou mutation professionnelle)",
      "Plafond : 1 500 € d’indemnisation par an (2 sinistres maximum)",
    ],
    disclaimer: "Garanties, exclusions, justificatifs, plafonds et conditions de remboursement selon les conditions contractuelles Assurtacotiz (voir document ci-dessous).",
    docUrl: "/cg-assurtacotiz.pdf",
  },
};

export const MENU = [
  { to: "/", label: "Accueil" },
  { to: "/association", label: "L'association" },
  {
    label: "Nos pôles",
    children: POLES.map((p) => ({ to: `/poles/${p.slug}`, label: p.name })),
  },
  { to: "/cours", label: "Cours" },
  { to: "/planning", label: "Planning" },
  { to: "/tarifs", label: "Tarifs" },
  { to: "/equipe", label: "Équipe" },
  { to: "/evenements", label: "Agenda" },
  { to: "/lieux", label: "Lieux" },
  { to: "/galerie", label: "Galerie" },
  { to: "/contact", label: "Contact" },
];
